import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const StarIcon = ({ active = false }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 0.867001L10.318 5.563L15.5 6.316L11.75 9.971L12.635 15.133L8 12.696L3.365 15.133L4.25 9.971L0.5 6.316L5.682 5.563L8 0.867001Z"
            stroke={active ? colors.primary : 'black'}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                fill: active ? colors.primary : 'transparent',
            }}
        />
    </svg>
);

StarIcon.propTypes = {
    active: PropTypes.bool,
};

export default StarIcon;
